import React from "react";
import HIDCustomLogo from "../auth/login/HIDCustomLogo";
import { Loader, LoaderSizes } from "@hid-galaxy-ui/galaxy-react";
import "./SuspenseFallback.scss"

const SuspenseFallback = () => {
  return (
    <div className="suspense-fallback-container">
      <div className="logo-wrapper">
        <HIDCustomLogo />
      </div>
      <div className="message-box">
        <Loader variant={LoaderSizes.medium} />
        <p>Loading...</p>
      </div>
    </div>
  );
};

export default SuspenseFallback;
